const API_BASE_URL = import.meta.env.VITE_APP_BASE_API;

const generateApiEndpoint = (endpoint) => `${API_BASE_URL}${endpoint}`;

export default generateApiEndpoint;
